import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'CmgRadioButton',
})
export default class CmgRadioButton extends Vue {
    @Prop({ type: Boolean })
    active?: boolean | null;

    @Prop({ type: String })
    borderColor?: string;

    @Prop({ type: String })
    additionalArialabel?: string;

    @Prop({ default: 'gold', type: String })
    backgroundColor?: string;

    @Prop({ type: Number, default: 20 })
    dimensions?: number;

    get dims(): string {
        return this.dimensions && isNaN(this.dimensions) ? '' : `${this.dimensions}px`;
    }

    get activeLabel(): string {
        return this.active ? (this.additionalArialabel ? this.additionalArialabel : '') : (this.additionalArialabel ? this.additionalArialabel : '');
    }

    get checkStyle() {
        if (this.dimensions != null) {
            return {
                height: `${this.dimensions * .625}px`,
                width: `${this.dimensions * .25}px`,
            };
        }
    }
}
